import { combineReducers } from "redux";
import LoginReducer from "services/reducers/parts/LoginReducer";
import GetInfoReducer from "services/reducers/parts/GetInfoReducer";


export default combineReducers({
  LoginReducer,
  GetInfoReducer
});
